// extracted by mini-css-extract-plugin
module.exports = {"best-companies-container":"BestCompaniesToWork_best-companies-container__kYevZ"};